export const BigHouse = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <title>house-retro</title>
    <path
      d="M2.396 12.938v6.708a0.958 0.958 0 0 0 0.958 0.958h16.292a0.958 0.958 0 0 0 0.958 -0.958v-6.708"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M8.146 12.938H1.206a0.479 0.479 0 0 1 -0.439 -0.671l2.464 -5.75a0.479 0.479 0 0 1 0.441 -0.287h5.578"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M13.75 6.229h5.579a0.479 0.479 0 0 1 0.441 0.287l2.464 5.75a0.479 0.479 0 0 1 -0.44 0.671H14.854"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m4.313 2.396 0 3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.229 6.229 0 -3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m3.369 2.396 3.818 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.771 2.396 0 3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.688 6.229 0 -3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m15.828 2.396 3.818 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m8.146 10.063 0 10.542"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m14.854 20.604 0 -10.542"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.123 3.852a0.479 0.479 0 0 1 0.753 0l4.283 5.436a0.479 0.479 0 0 1 -0.377 0.775H7.217a0.479 0.479 0 0 1 -0.377 -0.775Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M16.771 14.854h1.917v1.917h-1.917Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M4.313 14.854h1.917v1.917h-1.917Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M12.938 20.604V16.292a1.438 1.438 0 0 0 -2.875 0v4.313"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const CityCenter = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.854 0.979a0.479 0.479 0 0 1 0.479 -0.479h6.702a0.479 0.479 0 0 1 0.479 0.479V22.042a0.479 0.479 0 0 1 -0.479 0.479H14.854Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m14.85 22.521 -7.658 0 0 -10.531 7.658 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.36 8.498a0.479 0.479 0 0 0 -0.678 0l-3.49 3.491H14.854Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.192 22.521H1.926a0.479 0.479 0 0 1 -0.479 -0.479v-4.313h5.745"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.192 14.862H2.661a0.479 0.479 0 0 0 -0.399 0.213l-1.277 1.917a0.479 0.479 0 0 0 0.399 0.745h5.808"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.765 2.416 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.68 2.416 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.595 2.416 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.765 6.245 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.68 6.245 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.595 6.245 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.765 10.075 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.68 10.075 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.595 10.075 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.765 13.904 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.68 13.904 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.595 13.904 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m9.166 15.319 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m11.081 15.319 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.996 15.319 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m9.166 19.148 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m11.081 19.148 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m12.996 19.148 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.765 17.734 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.68 17.734 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.595 17.734 0 0.957"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M8.21 6.245a2.113 2.113 0 0 0 1.852 -2.06 2.057 2.057 0 0 0 -2.133 -2.055A2.875 2.875 0 0 0 5.327 0.479a2.971 2.971 0 0 0 -2.971 2.709A1.545 1.545 0 0 0 0.491 4.701a1.565 1.565 0 0 0 1.647 1.545Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const FirePlace = () => (
  <svg
    id="Light"
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <title>fireplace</title>
    <path
      d="M11.793 9.354a0.479 0.479 0 0 0 -0.671 0.618 3.892 3.892 0 0 1 -0.096 3.473 2.769 2.769 0 0 1 -0.822 -0.958 0.479 0.479 0 0 0 -0.671 -0.221 3.399 3.399 0 0 0 -1.844 3.081 3.812 3.812 0 1 0 7.624 0 7.028 7.028 0 0 0 -3.52 -5.992Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M1.093 2.396a0.479 0.479 0 0 0 -0.465 0.595l0.719 2.875a0.479 0.479 0 0 0 0.465 0.363h0.585v14.375h2.875v-14.375h12.458v14.375h2.875v-14.375h0.585a0.479 0.479 0 0 0 0.465 -0.363l0.719 -2.875a0.479 0.479 0 0 0 -0.465 -0.595Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m5.271 20.604 12.458 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.396 6.229 3.355 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.396 9.104 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.396 11.979 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.396 14.854 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.396 17.729 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.729 9.104 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.729 11.979 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.729 14.854 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.729 17.729 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.729 6.229 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const HouseModern = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m0.979 42.104 45.042 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.979 26.438 19.583 -7.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m4.896 24.908 0 17.196"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.625 4.896 28.396 17.625"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m42.104 20.134 0 21.971"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M36.229 16.464V9.792a0.979 0.979 0 0 1 0.979 -0.979h1.958a0.979 0.979 0 0 1 0.979 0.979v9.089"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M37.208 42.104a0.979 0.979 0 0 0 0.979 -0.979v-5.875a0.979 0.979 0 0 0 -0.979 -0.979h-11.75a0.979 0.979 0 0 0 -0.979 0.979v5.875a0.979 0.979 0 0 0 0.979 0.979"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m32.313 34.271 0 7.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M26.439 22.521a2.938 2.938 0 1 0 5.875 0 2.938 2.938 0 1 0 -5.875 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M15.667 42.104a0.979 0.979 0 0 0 0.979 -0.979v-7.833a0.979 0.979 0 0 0 -0.979 -0.979H9.792a0.979 0.979 0 0 0 -0.979 0.979v7.833a0.979 0.979 0 0 0 0.979 0.979"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.563 6.762 0 35.342"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const OutdoorTrees = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="m11.711 12.612 -1.917 -2.473a0.901 0.901 0 1 0 1.294 -1.265l-2.568 -3.067c0.891 0.882 2.099 -0.345 1.208 -1.342L6.929 1.485a0.958 0.958 0 0 0 -1.399 0L2.731 4.466c-0.891 0.958 0.316 2.223 1.208 1.342l-2.549 3.067a0.901 0.901 0 1 0 1.294 1.265l-1.917 2.473a0.901 0.901 0 0 0 0.633 1.543h9.679a0.901 0.901 0 0 0 0.633 -1.543Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m21.812 10.781 -2.175 -2.875c0.757 0.843 1.667 -0.383 1.035 -1.265l-2.175 -2.875a0.958 0.958 0 0 0 -0.767 -0.383 0.958 0.958 0 0 0 -0.767 0.383l-2.166 2.837c-0.633 0.882 0.268 2.108 1.025 1.265l-2.166 2.875a0.891 0.891 0 0 0 0.441 1.457h7.264a0.891 0.891 0 0 0 0.45 -1.418Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m6.229 14.155 0 3.948"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m17.729 12.238 0 2.913"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M0.479 18.448a16.292 16.292 0 0 1 14.375 3.373"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.088 17.25a14.375 14.375 0 0 1 11.433 -1.62"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const PetPaw = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.725 12.167a1.548 1.548 0 0 0 -0.538 -0.491 1.438 1.438 0 0 0 -1.376 0 1.547 1.547 0 0 0 -0.538 0.491l-2.313 3.373a1.805 1.805 0 0 0 -0.127 1.742c0.125 0.271 0.316 0.501 0.556 0.664 0.239 0.163 0.515 0.254 0.797 0.262h4.626a1.485 1.485 0 0 0 0.8 -0.262c0.24 -0.163 0.433 -0.393 0.56 -0.665a1.766 1.766 0 0 0 -0.134 -1.717l-2.312 -3.397Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.75 12.458a1.917 1.917 0 1 0 0 -3.833 1.917 1.917 0 0 0 0 3.833Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.5 8.625a1.917 1.917 0 1 0 0 -3.833 1.917 1.917 0 0 0 0 3.833Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.25 12.458a1.917 1.917 0 1 0 0 -3.833 1.917 1.917 0 0 0 0 3.833Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.5 22.521c6.086 0 11.021 -4.934 11.021 -11.021S17.586 0.479 11.5 0.479 0.479 5.414 0.479 11.5 5.414 22.521 11.5 22.521Z"
      strokeWidth="1"
    ></path>
  </svg>
);

export const TrainStation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <path
      d="m0.958 22.281 21.083 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.958 17.49 21.083 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.875 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.325 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m9.775 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m13.225 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m16.675 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m20.125 17.49 0 4.792"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M2.086 6.994h4.931v7.621H2.086Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M15.982 6.994h4.931v7.621h-4.931Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 0.719 7.018 5.201l0 9.414 8.964 0 0 -9.414L11.5 0.719z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m10.155 2.063 -8.069 0 -0.896 4.931 5.827 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m15.983 6.994 5.827 0 -0.896 -4.931 -8.069 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.5 8.338h0a1.793 1.793 0 0 1 1.793 1.793v4.484l0 0h-3.586l0 0v-4.482A1.793 1.793 0 0 1 11.5 8.338Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const TreeHouse = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="m17.576 3.92 -3.354 2.98a0.958 0.958 0 0 0 -0.326 0.767v4.313a0.958 0.958 0 0 0 0.958 0.958h6.708a0.958 0.958 0 0 0 0.958 -0.958V7.667a0.958 0.958 0 0 0 -0.326 -0.719l-3.354 -2.98a0.958 0.958 0 0 0 -1.265 -0.048Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m16.771 12.938 0 9.583"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m19.646 12.938 0 9.583"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m16.771 15.333 2.875 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m16.771 18.208 2.875 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m16.771 21.083 2.875 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M20.604 12.938V10.542A2.396 2.396 0 0 0 18.208 8.146h0a2.396 2.396 0 0 0 -2.396 2.396v2.396"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m10.063 6.708 0 15.813"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M10.063 11.979a3.776 3.776 0 0 0 1.581 -0.345"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M10.063 10.063a2.875 2.875 0 0 1 -2.875 -2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M13.005 15.333a4.935 4.935 0 0 1 -2.942 -0.767 5.357 5.357 0 0 1 -3.163 0.767c-3.067 0 -4.121 -2.357 -4.082 -3.115a3.182 3.182 0 0 1 -2.338 -2.875 3.172 3.172 0 0 1 2.281 -2.875A2.731 2.731 0 0 1 5.75 3.833l0.297 -0.24C6.028 1.917 7.724 0.479 9.823 0.479s3.833 1.399 3.833 3.115l0.297 0.24a3.316 3.316 0 0 1 0.882 0.115"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Quiet = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <title>outdoor-beach</title>
    <path
      d="M8.317 7.694a40.175 40.175 0 0 0 -2.683 14.814"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.242 7.029c-3.327 4.063 -4.549 9.247 -4.549 15.478"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M14.199 17.561c-2.333 0 -6.837 -0.679 -7.864 -1.677a8.792 8.792 0 0 0 7.935 5.449 9.304 9.304 0 0 0 8.303 -5.449c-1.028 0.998 -6.041 1.677 -8.374 1.677Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.829 6.996a4.456 4.456 0 0 0 -1.493 -5.769A3.921 3.921 0 0 0 2.971 0.628 5.979 5.979 0 0 0 0.654 1.783l-0.226 0.176C3.655 2.77 6.346 4.193 7.829 6.996Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.652 6.93A3.505 3.505 0 0 0 3.45 4.915a2.908 2.908 0 0 0 -1.959 1.725A4.729 4.729 0 0 0 1.093 8.625v0.225c2.021 -1.536 4.159 -2.442 6.559 -1.921Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.945 6.959a4.458 4.458 0 0 1 4.644 -3.733 3.923 3.923 0 0 1 3.055 1.533 5.975 5.975 0 0 1 1.169 2.312l0.076 0.276c-3.072 -1.281 -6.081 -1.749 -8.944 -0.388Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M8.021 7.153a3.507 3.507 0 0 1 4.572 0.894 2.905 2.905 0 0 1 0.538 2.556 4.717 4.717 0 0 1 -0.863 1.83l-0.134 0.181c-0.704 -2.442 -1.88 -4.446 -4.113 -5.462Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);
